import React from 'react';
import { motion } from 'framer-motion';
import { Cpu, ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <div className="relative overflow-hidden bg-gate-dark pt-16 pb-24 sm:pt-24 sm:pb-32" data-id="element-132">
      {/* Circuit Background Pattern */}
      <div className="absolute inset-0 z-0 opacity-20 pointer-events-none" data-id="element-133">
        <div className="absolute inset-0 bg-circuit-pattern bg-circuit-size [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_70%)]" data-id="element-134"></div>

        {/* Animated Circuit Lines (CSS only simulation via positioning) */}
        <div className="absolute top-1/4 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gate-teal to-transparent opacity-30" data-id="element-135"></div>
        <div className="absolute top-3/4 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gate-teal to-transparent opacity-30" data-id="element-136"></div>
        <div className="absolute left-1/4 top-0 w-[1px] h-full bg-gradient-to-b from-transparent via-gate-teal to-transparent opacity-30" data-id="element-137"></div>
        <div className="absolute right-1/4 top-0 w-[1px] h-full bg-gradient-to-b from-transparent via-gate-teal to-transparent opacity-30" data-id="element-138"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-140">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gate-teal/10 border border-gate-teal/20 text-gate-teal text-sm font-medium mb-8" data-id="element-141">
            <Cpu className="w-4 h-4" data-id="element-142" />
            <span data-id="element-143">Now supporting Intel Agilex 7 FPGAs</span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-white mb-6" data-id="element-144">
            The Unified Interface For <br className="hidden sm:block" data-id="element-145" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gate-teal to-blue-500 glow-text-teal" data-id="element-146">
              FPGA Inference
            </span>
          </h1>

          <p className="mt-4 text-xl text-gate-text-secondary max-w-2xl mx-auto mb-10" data-id="element-147">
            Better <span className="text-gate-teal font-medium" data-id="element-148">latency</span>,
            better{' '}
            <span className="text-gate-teal font-medium" data-id="element-149">power efficiency</span>
            , no vendor lock-in. Access the world's most powerful programmable
            hardware through a single API.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-150">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeA3akOwONwkYJLK4nX5RaNw1wlVWWLd6dPKvH2FSMPjvA9IA/viewform" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-gate-teal text-gate-dark font-bold text-base hover:bg-gate-teal/90 transition-all shadow-[0_0_20px_-5px_rgba(0,212,170,0.5)] flex items-center justify-center gap-2" data-id="element-151">
              Get API Key
            </a>
            <a href="#" className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-transparent border border-gate-border text-white font-medium text-base hover:bg-gate-surface hover:border-gate-teal/50 transition-all flex items-center justify-center gap-2 group" data-id="element-152">
              Explore Accelerators
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-153" />
            </a>
          </div>
        </motion.div>
      </div>
    </div>;
}